import { Link } from "react-router-dom";
import ProjectTile from "./ProjectTile";
import { projectData } from "../utlis/ProjectData";

export default function Projects(): JSX.Element {
  return (
    <div className="Projects">
      <Link to="/" id="homeLink">
        Home
      </Link>
      <h4>Click on a Project!</h4>
      <div className="carousel">
        {projectData.map((oneProjectData, index) => (
          <ProjectTile
            key={index}
            title={oneProjectData.title}
            src={oneProjectData.src}
            alt={oneProjectData.alt}
            description={oneProjectData.description}
            url={oneProjectData.url}
            tag={oneProjectData.tag}
          />
        ))}
      </div>
    </div>
  );
}
